import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://xaintro-backend.onrender.com';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const orderService = {
  getOrders: async (params = {}) => {
    try {
      const response = await api.get('/orders', { params });
      return response.data;
    } catch (error) {
      // Handle authentication errors
      if (error.response?.status === 401 || error.response?.status === 403) {
        throw new Error('Authentication required. Please login.');
      }
      throw error;
    }
  },

  getOrder: async (id) => {
    try {
      const token = localStorage.getItem('token');
      console.log('🔑 OrderService: Token exists:', !!token);
      console.log('📞 OrderService: Fetching order:', id);

      const response = await api.get(`/orders/${id}`);
      console.log('✅ OrderService: Order fetched successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ OrderService: Error fetching order:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        url: error.config?.url
      });

      if (error.response?.status === 401 || error.response?.status === 403) {
        throw new Error('Authentication required. Please login.');
      }
      throw error;
    }
  },

  updateOrderStatus: async (id, statusData) => {
    try {
      const response = await api.put(`/orders/${id}/status`, statusData);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        throw new Error('Authentication required. Please login.');
      }
      throw error;
    }
  },
};

export default orderService;
